import { lazy } from 'react';

// project imports
import MainLayout from '../layout/MainLayout';
import Loadable from '../ui-component/Loadable';


//Policy
const Ads = Loadable(lazy(() => import('views/ads/index')));


// ==============================|| MAIN ROUTING ||============================== //

const PolicyRoutes = {
    path: '/app-ads.txt',
    element: < Ads />

}
    ;

export default PolicyRoutes;